import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const copyShopifyIntegration = unaryRpc({
  name: "copyShopifyIntegration",
  input: z.object({
    sourceTeamId: zExt.objectId(),
    destinationTeamId: zExt.objectId(),
    /** Added to the integration's existing exclusion tags as it moves. */
    orderExclusionTags: z.array(z.string()).optional(),
    /** Restarts the order backfill from now back to this date as it moves. */
    ordersBackfillMin: z.date().optional(),
  }),
  output: z.object({ success: z.boolean(), message: z.string() }),
});
